export default {
    ragClasses: {
        background: {
            red: 'rag-red',
            amber: 'rag-amber',
            green: 'rag-green',
            gray: 'bg-dark-2'
        },
        text: {
            red: 'rag-red-text',
            amber: 'rag-amber-text',
            green: 'rag-green-text',
            gray: 'text-light'
        },
        hex: {
            red: '#FF5951',
            amber: '#ECBD2B',
            green: '#73CB53',
            gray: '#2D2D34'
        }
    },
    themeColors: {
        primary: '#0093de',
        secondary: '#17577a',
        dark: '#1B1B1B',
        light: '#8D8D8D',
        light2: '#BCBCBC',
        light3: '#F1F1F1'
    },
    statusColors: {
        red: 'red',
        gray: 'bg-dark-2',
        blue: 'blue',
        green: 'green',
        purple: 'purple',
        yellow: 'yellow'
    },
    chartColors: {
        primary: '#2a9b98',
        secondary: '#915196',

        scoreInfo: {
            high: '#fa88f4',
            med: '#d669cf',
            low: '#8d4e8a'
        }
    },
    segmentationsColors: {
        red: '#FF5951',
        amber: '#ECBD2B',
        green: '#73CB53',
        purple: '#b767cb',
        lightGreen: '#a1cb39'
    }
}
